import { render, staticRenderFns } from "./WishListProduct.vue?vue&type=template&id=66400c74&scoped=true&"
import script from "./WishListProduct.vue?vue&type=script&lang=js&"
export * from "./WishListProduct.vue?vue&type=script&lang=js&"
import style0 from "./WishListProduct.vue?vue&type=style&index=0&id=66400c74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66400c74",
  null
  
)

export default component.exports